import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { percentageList, rewardsList } from '@utils/contstant';
import { useSelector } from 'react-redux';
// import RewardList from './RewardList';
import { addRewards, updateRewards } from '../../actions/business';
const { Text } = Typography;

const { TextArea } = Input;

export const Rewards = ({ handleClose, setAtiveStep, setCurrentData, currentData }: any) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const user = useSelector((state: any) => state?.Auth);
    const [referralRewardType, setReferralRewardType] = useState(currentData?.referralRewardType || '')
    const [referrerRewardType, setReferrerRewardType] = useState(currentData?.referrerRewardType || '')
    const [description, setDescription] = useState('');

    const onFinish = (values: any) => {
        const formData = {
            ...values,
            // referralRewardType : (values?.referralRewardType &&  values?.referralRewardType !== 'no-reward') ? values?.referralRewardType : "",
            referrerRewardType : (values?.referrerRewardType &&  values?.referrerRewardType !== 'no-reward') ? values?.referrerRewardType : "",
            // referralRewardValue : values?.referralRewardValue ? values?.referralRewardValue?.toString() : "",
            referrerRewardValue : values?.referrerRewardValue?.toString() ? values?.referrerRewardValue?.toString() : ""
        };

        if(currentData?.id){
            formData.id = currentData?.id
            dispatch(updateRewards(formData, (resp: any)=> {
                setAtiveStep('3')
                handleClose()
            }))
        } else {
            dispatch(addRewards(formData, (resp: any)=> {
                setAtiveStep('3')
                handleClose()
            }))
        }
        // Reset specified fields in the form
        form.setFieldsValue({
            referrerRewardValue: '',
            // referralRewardValue: '',
            // referralRewardType: '',
            referrerRewardType: '',
            rewardName: '',
            description: '',
        });
    };

    useEffect(()=> {
        form.setFieldsValue({
            ...currentData
        })
        // setReferralRewardType(currentData?.referralRewardType || '')
        setReferrerRewardType(currentData?.referrerRewardType || '')
    }, [currentData])

    const handleRewardChange = (type:string, value: string) => {
       if(type === 'referral'){
        //    setReferralRewardType(value);
       } else {
          setReferrerRewardType(value)
       }
    };

    const handleCancel = () => {
        // Reset specified fields in the form
        form.setFieldsValue({
            referrerRewardValue: '',
            // referralRewardValue: '',
            // referralRewardType: '',
            referrerRewardType: '',
            rewardName: '',
            description: '',
        });
    
        // Reset current data and state values
        setCurrentData(); 
        // setReferralRewardType('');
        setReferrerRewardType('');
        
        // Close the modal or component
        handleClose();
    };

    const renderReferrerValue = () => {
        switch (referrerRewardType) {
            case 'percentage': {
                return (
                    <Form.Item
                        name="referrerRewardValue"
                        label="Referrer Reward Value"
                        className='formControlDesign'
                        rules={[
                            {
                                required: true,
                                message: 'Please select referrer reward value!',
                            }
                        ]}
                    >
                        <Select placeholder="Referral Reward">
                            {percentageList?.map((item: any, index: number) => {
                                return <Select.Option key={index} value={item?.value ?? ''}>{item?.label}</Select.Option>
                            })}
                        </Select>
                    </Form.Item>
                )
            }
            case 'cash': {
                return <Form.Item
                    name="referrerRewardValue"
                    label="Referrer Reward Value"
                    className='formControlDesign'
                >
                    <Input placeholder='Enter cash commission' />
                </Form.Item>
            }
            default: {
                return ''
            }
        }
    }

    // ******* Will be used in next phase *************** //
    const renderReferralValue = () => {
        switch (referralRewardType) {
            case 'percentage': {
                return (
                    <Form.Item
                        name="referralRewardValue"
                        label="Referral Reward Value"
                        className='formControlDesign'
                        colon={false}
                    >
                        <Select placeholder="Referrer Reward">
                            {percentageList?.map((item: any, index: number) => {
                                return <Select.Option key={index} value={item?.value ?? ''}>{item?.label}</Select.Option>
                            })}
                        </Select>
                    </Form.Item>
                )
            }
            case 'cash': {
                return <Form.Item
                    name="referralRewardValue"
                    label="Referral Reward Value"
                    className='formControlDesign'
                    colon={false}
                >
                    <Input placeholder='Enter cash commission' />
                </Form.Item>
            }
            default: {
                return ''
            }
        }
    }

    return (
        <div>
            <Form
                className="formControl"
                form={form}
                onFinish={onFinish}
                initialValues={{ ...currentData }}
            >
                <Form.Item
                    className="formControlDesign"
                    label="Reward Name"
                    colon={false}
                    name="rewardName"
                    rules={[
                        {
                            required: true,
                            message: 'Required.',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input placeholder='Enter Reward Name' />
                </Form.Item>

                
                <Row>
                    <Col md={11} lg={11} sm={24}>
                        <Form.Item
                            name="referrerRewardType"
                            label="Referrer Reward"
                            className='formControlDesign'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select referrer reward!',
                                }
                            ]}
                        >
                            <Select placeholder="Referrer Reward" onChange={(value: any) => handleRewardChange('referrer', value)}>
                                {rewardsList?.map((item: any, index: number) => {
                                    return <Select.Option key={index} value={item?.value}>{item?.label}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col offset={2} md={11} lg={11} sm={24}>
                        {renderReferrerValue()}
                    </Col>
                </Row>

                {/* Will be used in next phase */}
                {/* <Row>
                    <Col md={11} lg={11} sm={24}>
                        <Form.Item
                            name="referralRewardType"
                            label="Referral Reward"
                            className='formControlDesign'
                            colon={false}
                        >
                            <Select placeholder="Referral Reward" onChange={(value: any) => handleRewardChange('referral', value)}>
                                {rewardsList?.map((item: any, index: number) => {
                                    return <Select.Option key={index} value={item?.value}>{item?.label}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col offset={2} md={11} lg={11} sm={24}>
                        {renderReferralValue()}
                    </Col>
                </Row> */}
                <Row>
                    <Col lg={24}>
                        <Form.Item
                            name="description"
                            label="Reward Description (250 Character allowed)"
                            className='formControlDesign'
                            colon={false}
                        >
                            <TextArea onChange={(evt) =>setDescription(evt.target.value)} maxLength={250} rows={3} placeholder='Enter Description' />
                        </Form.Item>
                        <div className={description.length === 250 ? "text-danger" : 'text-success'}>
                            {description.length}/{250} characters
                        </div>
                    </Col>
                </Row>

                <div className="text-end btn-groups-Forms mt-15">
                    <button type='button' className="btn btn-outline-primary" onClick={()=> handleCancel()}>Cancel</button>
                    <button className="btn btn-primary" type="submit">
                        Submit
                    </button>
                </div>
            </Form>
        </div>
    );
};
